import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'aa-oups',
    templateUrl: './oups.component.html',
    styleUrls: [
        './oups.component.scss'
    ],
    standalone: false
})
export class OupsComponent implements OnInit
{
    @Input() title: string = '';
    @Input() message: string = '';

    constructor() { }

    ngOnInit ()
    {
    }
}
